import type {Area, MediaSize, Point, Size} from 'react-easy-crop';

function getFitZoom(media: Size, frame: Size) {
  return Math.min(1, frame.width / media.width, frame.height / media.height);
}

function clampAxis(position: number, media: number, frame: number, zoom: number) {
  const limit = Math.abs(media * zoom - frame) / 2;
  return Math.min(limit, Math.max(-limit, position));
}

function clampCropPosition(position: Point, media: Size, frame: Size, zoom: number) {
  return {
    x: clampAxis(position.x, media.width, frame.width, zoom),
    y: clampAxis(position.y, media.height, frame.height, zoom),
  };
}

function getCropArea(position: Point, media: MediaSize, frame: Size, zoom: number): Area {
  const toNatural = media.naturalWidth / media.width;
  const width = frame.width / zoom;
  const height = frame.height / zoom;

  return {
    x: Math.round(((media.width - width) / 2 - position.x / zoom) * toNatural),
    y: Math.round(((media.height - height) / 2 - position.y / zoom) * toNatural),
    width: Math.round(width * toNatural),
    height: Math.round(height * toNatural),
  };
}

export {clampCropPosition, getCropArea, getFitZoom};
